import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Headers } from "@angular/http";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { delay } from "rxjs/operators";
import { HttpClientService } from "../../Services/http-client.service";
import { SessionService } from "../../Services/session.service";
import { UserService } from "../../Services/user.service";
import { AppSettings } from "../../app-settings";

declare var bz_fire_login_event_log: any;
@Component({
  selector: "app-recent-activity-body",
  templateUrl: "./recent-activity-body.component.html",
  styleUrls: ["./recent-activity-body.component.css"],
})
export class RecentActivityBodyComponent implements OnInit {
  data: any = {};
  graph: Object = {
    width: 480,
    height: 200,
  };
  PspDataLoading: boolean = true;
  dataPsp: any = [];
  statusMapping = {
    COMPLETED_AUTO: { Color: "#5c9d07", displayName: "Completed" },
    COMPLETED_MANUAL: { Color: "#5c9d07", displayName: "Completed" },
    REVISION: { Color: "#5c9d07", displayName: "Revision" },
    INPROGRESS: { Color: "#ec6f0a", displayName: "In Progress" },
  };
  days = [
    { day: "monday", done: false },
    { day: "tuesday", done: false },
    { day: "wednesday", done: false },
    { day: "thurusday", done: false },
    { day: "friday", done: false },
    { day: "saturday", done: false },
    { day: "sunday", done: false },
  ];

  workDone = 0;
  totalTime: number;
  hours: number = 0;
  minutes: number = 0;
  resume: any;
  nextActivity: any;
  firstName: String;
  graphHover: any;
  previousUrl: string;
  userInfoSubscription: Subscription;
  gmatPlanExecutionState: string = 'DUMMY';
  isFreeTrialUser: boolean = false;
  maxTime: number = 0;

  infoApiDone: boolean = false;
  calendarApiDone: boolean = false;
  recentApiDone: boolean = false;

  graphicImgUrl = AppSettings.cdnUrl + "assets/images/graphic.png";

  constructor(
    private httpClientService: HttpClientService,
    private userService: UserService,
    router: Router,
    private sessionService: SessionService
  ) {
    this.resume = AppSettings.cdnUrl + "assets/images/resume.png";
    this.nextActivity = AppSettings.cdnUrl + "assets/images/next.png";
    this.graphHover = AppSettings.cdnUrl + "assets/images/hover-time.png";
  }

  getFirstName() {
    this.userInfoSubscription = this.sessionService.getUserInfo$.subscribe(
      (item) => {
        if (item != "") {
          this.infoApiDone = true;
          this.isFreeTrialUser = item.courseEnrollments.freeTrial;
          this.firstName = item.firstName;
          this.gmatPlanExecutionState = item.gmatPlanExecutionState;
          if (item.gmatPlanExecutionState == "EXECUTE") {
            this.getPspData(item.gmatPlanId);
          }else{
            this.calendarApiDone = true;
          }
        }
      }
    );
  }

  getPspData(planId) {
    let headers = new HttpHeaders();
    this.httpClientService
      .get(
        AppSettings.restApiUrl + "/api/gmatplan/" + planId + "/calender-task",
        headers
      )
      .pipe(delay(500))
      .subscribe((result) => {
        // result['primaryTasks'] = [];
        this.dataPsp = result;
        this.PspDataLoading = false;
        this.calendarApiDone = true;
      });
  }

  goToPspPlan() {
    window.open(AppSettings.gfePSPUrl, "_blank");
  }

  ngOnInit() {
    this.getFirstName();
    let headers = new HttpHeaders();
    this.httpClientService
      .get(AppSettings.restApiUrl + "/api/recentActivities", headers)
      .subscribe((data) => {
        this.data = data;
        this.recentApiDone = true;
      });
  }

  ngOnDestroy() {
    this.userInfoSubscription.unsubscribe();
  }
}
